import { PARTNER_NAME, PARTNER_TYPE } from "../../constants/datalayer";

export const isCallcenter = (channel = "") => {
    if (!channel) {
        return false;
    }
    return channel.toLowerCase() === PARTNER_NAME.callcenter.toLowerCase();
};

export const getClearPath = ({ pathname, partner, partnerType }) => {
    const companyPathPrefix = partnerType === PARTNER_TYPE.company ? "/empresas" : "";
    const channelPathPrefix =
        partnerType !== PARTNER_TYPE.default && partner !== PARTNER_NAME.default
            ? `/${partner}`
            : "";
    const fullPathPrefix = `${companyPathPrefix}${channelPathPrefix}`;
    return pathname.replace(fullPathPrefix, "");
};
